export const ecgRoute = 'ecg-recordings';
export const jetLagRoute = 'jet-lag-trips';
export const bodyBatteryRoute = 'body-battery';
export const garminTrailsRoute = '0fa2a8b5-0312-4c85-98a8-e0d4b39881c4';
export const gc5FoxtrotRoute = 'b4552761-da1f-425f-ac3a-cf16a3dffc1f';
export const gcPlusRoute = 'subscription';
export const activityListRoute = '572e8b5b-017f-49d6-8ce9-71cdce6ab935';
